import React from 'react'
import "./Success_Modal.css"
import { Modal } from 'react-bootstrap'
import Successfull_Lottie from '../../../animation/Successfull_Lottie/Successfull_Lottie'

function Success_Modal({successText, ...props}) {
  return (
   <>
  <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='Success_Modal'
    >
     
      <Modal.Body>
        
        <div className='lottie_div'>
        <Successfull_Lottie/>
        </div>

        
        <p className='success_text'>{successText}</p>
      </Modal.Body>
    </Modal>
   </>
  )
}

export default Success_Modal